import * as React from 'react';
import { ICON } from 'resources/constants';
import { Wrapper, CloseButton, Title, Text } from './elements';

type InfoCardProps = {
  readonly className?: string;
  readonly title: string;
  readonly text: string;
  readonly canClose?: boolean;
  readonly onClick?: () => void;
  readonly small?: boolean;
};

function InfoCard({
  className,
  title,
  text,
  canClose,
  onClick,
  small,
}: InfoCardProps): React.ReactElement {
  return (
    <Wrapper className={className} small={small}>
      {canClose ? <CloseButton icon={ICON.close} onClick={onClick} /> : null}
      <Title small={small}>{title}</Title>
      <Text small={small}>{text}</Text>
    </Wrapper>
  );
}

export default InfoCard;
